import React from "react";

import { connect } from "react-redux";

import { Div } from "components/Base";

import Avatar from "Portal/NewPortal/Shared/Avatar";

import { getUserName, getActiveAccount, getIsEventAdmin } from "../selectors";

// import { isEmptyOrNil } from "utils/General";
import styleSpects from "components/Base/Base/styleSpecs";
import { noop } from "utils/General";

import MenuPopover from "./MenuPopover";
import SwitchPortals from "./SwitchPortals";

import { eventDetails as getEventDetails } from "redux/modules/portal/selectors";

import { push } from "react-router-redux";

const decorate = connect(
  state => ({
    name: getUserName(state),
    eventData: getEventDetails(state),
    activeAccount: getActiveAccount(state),
    isEventAdmin: getIsEventAdmin(state)
  }),
  { push }
);

const MenuItem = ({
  leftIcon = "",
  rightIcon = "",
  children,
  onClick = noop
}) => (
  <Div
    fs={2}
    px={3}
    py={2}
    onClick={onClick}
    display="row.flex-start.center"
    bg={{
      hover: "neutral0",
      default: "white"
    }}
    color="gray7"
    style={{ cursor: "pointer" }}
  >
    {leftIcon ? (
      <Div display="row.flex-start.center" width={14} mr={2}>
        <i
          className={`material-icons-outlined ${leftIcon}`}
          style={{ color: "#494949", fontSize: styleSpects.fontSize[2] }}
        >
          {leftIcon}
        </i>
      </Div>
    ) : (
      <Div width={10} />
    )}
    {rightIcon ? (
      <Div display="row.space-between.center" flex={1}>
        {children}
        <i
          className="material-icons"
          style={{ color: "#494949", fontSize: styleSpects.fontSize[2] }}
        >
          {rightIcon}
        </i>
      </Div>
    ) : (
      children
    )}
  </Div>
);

const ProfileDropdown = ({
  name = null,
  eventData = {},
  activeAccount = null,
  push,
  isEventAdmin
}) => {
  const displayName = activeAccount ? activeAccount.name : name;

  return (
    <MenuPopover
      Label={
        <Div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            color: "#343434",
            fontSize: "15px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "normal"
          }}
        >
          <Avatar name={displayName} square={false} />
          {displayName}
          <span
            class="material-icons-outlined"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            expand_more
          </span>
        </Div>
      }
    >
      {({ closePopover }) => (
        <Div bra={3} bg="white" width={200} py={2}>
          <SwitchPortals />

          {isEventAdmin ? (
            <MenuItem
              leftIcon={"manage_accounts"}
              onClick={() => {
                window.location = `/event-light/${eventData.id}/dashboard`;
                closePopover();
              }}
            >
              Back to Admin Mode
            </MenuItem>
          ) : null}

          <Div
            style={{
              alignSelf: "stretch",
              height: "1px",
              background: "#e7e6ea"
            }}
            width={1}
          />
          <MenuItem
            leftIcon={"logout"}
            onClick={() => {
              push(
                `/logout?returnTo=/portal-login/${eventData.slug}/${eventData.uuid}`
              );
              closePopover();
            }}
          >
            Logout
          </MenuItem>
        </Div>
      )}
    </MenuPopover>
  );
};

export default decorate(ProfileDropdown);
